import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LearningAreaApi } from '../+api';
import { LearningAreaInterface } from '../+models/LearningArea.interface';
import { LearningAreaServiceInterface } from './learning-area.service.interface';

@Injectable({
  providedIn: 'root',
})
export class LearningAreaService implements LearningAreaServiceInterface {
  private learningAreaApi = inject(LearningAreaApi);

  constructor() {}

  getAll(): Observable<LearningAreaInterface[]> {
    return this.learningAreaApi.find().pipe(map((learningAreas) => learningAreas.map(this.addIconPrefix)));
  }

  getLearningAreas$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: LearningAreaInterface[]; count: number }> {
    const params = new HttpParams({
      fromObject: {
        searchTerm: searchTerm || '',
        filters: JSON.stringify(filters || {}),
        columns: JSON.stringify(columns || null),
        sorting: JSON.stringify(sorting || {}),
        pagination: JSON.stringify(pagination || {}),
      },
    });
    return this.learningAreaApi.getLearningAreas(params);
  }

  // TODO: remove when DB is updated
  private addIconPrefix(learningArea: LearningAreaInterface): LearningAreaInterface {
    if (learningArea.icon && !learningArea.icon.startsWith('learning-area:')) {
      return { ...learningArea, icon: 'learning-area:' + learningArea.icon };
    }

    return learningArea;
  }

  createLearningArea(learningArea: LearningAreaInterface): Observable<LearningAreaInterface> {
    return this.learningAreaApi.createLearningArea(learningArea);
  }

  updateLearningArea(learningArea: LearningAreaInterface): Observable<LearningAreaInterface> {
    const params = new HttpParams({
      fromObject: {
        id: learningArea.id?.toString(),
      },
    });
    return this.learningAreaApi.updateLearningArea(params, learningArea);
  }

  deleteLearningArea(learningArea: LearningAreaInterface): Observable<boolean> {
    return this.learningAreaApi.deleteById(learningArea.id);
  }
}
